// extracted by mini-css-extract-plugin
module.exports = {"anchor":"style_anchor__1XRHI","title":"style_title__RYbt0","redBackgroundColor":"style_redBackgroundColor__2S6CT","duplicateArticle":"style_duplicateArticle__3VtSl"};